import { call, put } from 'redux-saga/effects';

import { takeLatest } from '../../../utils/reduxSaga';
import { actions as sagaActions, DELETE_DATALIMIT } from './types';
import { actions as loaderReducActions } from '../../../partials/loader/reducers';
import { URLS } from '../../../consts/endpoints';
import RESPONSE_CODES from '../../../consts/responseCodes';
import { deleteData } from '../../../utils/http';
import showSnackbar from '../../../utils/showSnackbar';

export function removeDatalimit(id, setRefresh) {
  return {
    type: sagaActions[DELETE_DATALIMIT],
    id,
    setRefresh
  };
}

export function* deleteDatalimit({ id, setRefresh }) {
  yield put(loaderReducActions.startSpinLoader());

  const response = yield call(deleteData, {
    url: `${URLS.DATA_LIMITS}/${id}`
  });

  if (response.status === RESPONSE_CODES.SUCCESS) {
    yield call(showSnackbar, {
      intlTextKey: 'MESSAGE.DELETE_DATALIMIT',
      messageType: 'success'
    });

    yield call(setRefresh(true));
  }
}

function* watchDeleteDatalimit() {
  yield takeLatest(sagaActions[DELETE_DATALIMIT], deleteDatalimit);
}

export default watchDeleteDatalimit();
